<template>
    <div class="pt-2">
        <div class="relative w-full px-4 py-4 mb-4 border border-gray-300 bg-gray-100">
            <form @submit.prevent="update">
                <h2 class="text-green-600 text-2xl leading-10 pr-8">{{selectedCourse?.programme_title ?? 'Select Programme'}}</h2>
                <p class="text-xl leading-10 pr-8 mb-2">{{selectedProgramme?.moa_name ?? 'Select Mode of Study'}}</p>
                <div class="flex flex-wrap">
                    <div class="w-full md:w-3/4 mr-0 md:pr-4">
                        <label>Programme title:</label>
                        <select v-model="selectedCourse" class="form-select mb-8 w-full bg-white" @change="changeCourse($event)">
                            <option v-for="programme in filteredCourses" :key="programme.reference" :value="programme">
                                {{ programme['programme_title'] ?? programme['sits_ipp'] }}
                            </option>
                        </select>
                    </div>
                    <div v-if="selectedCourse" class="w-full md:w-1/4">
                        <label>Mode of study:</label>
                        <select v-model="selectedProgramme" class="form-select mb-8 w-full bg-white" @change="changeProgramme($event)">
                            <option v-for="mode in filteredProgrammes" :key="mode.reference" :value="mode">
                                {{ mode['moa_name'] }} ({{ mode['moa_start_date'] }})
                            </option>
                        </select>
                    </div>

                    <div v-if="proposedStartDateShow" class="w-full flex flex-wrap">
                        <div class="w-full md:w-1/4 pr-4">
                            <label>* Proposed start date:</label>
                            <select v-if="proposedStartDateShow" v-model="proposedStartDate" class="form-select mb-8 w-full bg-white">
                                <option v-for="startDate in proposedStartDates" :key="startDate.date" :value="startDate.date">
                                    {{ startDate.date }}
                                </option>
                            </select>
                        </div>

                        <div class="w-full md:w-1/4">
                            <text-input v-model="proposedResearchTopic" :width="'full'" label="* Proposed research topic" @update:modelValue="value = $event" />
                            <label class="text-sm text-black-400">If you are applying for the Joint PhD in Global Health, you may provide details of up to two project titles.</label>
                        </div>

                        <div class="w-full md:w-1/4">
                            <text-input v-model="proposedSupervisor" :width="'full'" class="-mb-5" label="Proposed Supervisor" @update:modelValue="value = $event" />
                            <label class="text-sm text-black-400">(If you have already contacted an academic member of School staff who has expressed an interest in being your Supervisor, please give their name and Department and/or Faculty, if known.)</label>
                        </div>

                        <div class="w-full md:w-1/4">
                            <div class=" flex flex-wrap w-full">
                                <label class="mt-8 md:mt-0 w-full mb-2">* Are you an MRC Unit staff member?</label>
                                <div class="w-1/4 mr-3">
                                    <input id="1" :checked="mrcStaff===1" type="radio" value="1" name="mrcStaff" @input="mrcStaff = $event.target.value" />
                                    <label>Yes</label>
                                </div>
                                <div class="w-1/4 ml-3">
                                    <input id="0" :checked="mrcStaff===0" type="radio" value="0" name="mrcStaff" @input="mrcStaff = $event.target.value" />
                                    <label>No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="successMessage" class="success-message mt-4">{{ successMessage }}</div>
                    <div v-if="serverError" class="server-error w-full flex flex-wrap">
                        <ul>
                            <li v-for="(errors, key) in serverError.errors" :key="key">
                                <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="w-1/2 pb-2 mt-0 lg:-mt-8 w-full lg:w-1/2 text-right">
                    <div>
                        <application-component-save-button :disabled="true" class="relative w-full lg:w-2/3 flex justify-center btn-green ml-auto mt-8 md:inline-block text-center"
                                                           type="submit"
                        >
                            Save Programme Details
                            <div v-if="loading" class="lds-ring-container absolute top-2">
                                <div class="lds-ring">
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                </div>
                            </div>
                        </application-component-save-button>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
  components: {
    ApplicationComponentSaveButton,
    TextInput,
    SelectInput,
  },
  props: {
    chosenProgrammeType : String,
    academicYear : String,
    modeOfAttendance: Object,
    programmesList: Object,
    coursesList: Array,
    proposedStartDates: Object,
  },
  data() {
    return {
      selectedProgrammeMode: '',
      selectedProgramme: null,
      selectedCourse: null,
      filteredCourses: [],
      filteredProgrammes: [],
      proposedStartDate: '',
      proposedResearchTopic: '',
      proposedSupervisor: '',
      mrcStaff: '',
      proposedStartDateShow: false,
      form: {},
      formDirty: false,
      loading: false,
      successMessage: '',
      serverError: '',
      applicationRef: this.$route.params.id,
    }
  },
  mounted() {
      this.changeType({})
  },
  methods: {
    changeProgramme(event) {
      this.$emit('programmeChange', event.target.value)
    },
    changeCourse(event) {
      const filters = [
        {type: 'programme_type_sits_code', name: this.chosenProgrammeType},
        {type: 'programme_id', name: this.selectedCourse.reference},
        {type: 'sits_ipo_ayrc', name: this.academicYear},
      ]
      this.filteredProgrammes = this.programmesList.filter(el => filters.every(filterEl => {
        if(filterEl.name !== null && filterEl.name !== '' ) {
          return el[filterEl.type] === filterEl.name
        } else {
          return true
        }
      }))
    },
    changeType(event) {
      const programmeType = this.chosenProgrammeType
      if (programmeType === 'R') {
        this.proposedStartDateShow = true
      } else {
        this.proposedStartDateShow = false
        this.proposedStartDate = null
        this.proposedResearchTopic = null
        this.proposedSupervisor = null
        this.mrcStaff = null
      }

      const filters = [
        {type: 'programme_type_sits_code', name: programmeType},
      ]
      this.filteredCourses = this.coursesList.filter(el => filters.every(filterEl => {
        if(filterEl.name !== null && filterEl.name !== '' ) {
          return el[filterEl.type] === filterEl.name
        } else {
          return true
        }
      }))
      this.$emit('typeChanged', programmeType)
    },
    update() {
      this.$store.dispatch('updateProgrammeInstance', {
        selectedProgramme: this.selectedProgramme.reference,
        proposedStartDate: this.proposedStartDate,
        proposedResearchTopic: this.proposedResearchTopic,
        proposedSupervisor: this.proposedSupervisor,
        mrcStaff: this.mrcStaff,
        applicationRef: this.applicationRef,
      })
          .then(response => {
            this.loading = false
            this.serverError = ''
            this.successMessage = response.data
            this.$emit('refreshApplication', true)
            window.location.reload();
          })
          .catch(error => {
            this.loading = false
            this.serverError = error.response.data
            this.successMessage = ''
          })
      this.formDirty = false
    },
    dirtyForm() {
      this.formDirty = true
      this.successMessage = ''
    },
    cancelForm () {
      this.$emit('cancelForm')
    },
  },
}
</script>
